import { render, staticRenderFns } from "./SubscriptionForm.Purchase.InovioPayForm.vue?vue&type=template&id=2482ee6d&scoped=true&"
import script from "./SubscriptionForm.Purchase.InovioPayForm.vue?vue&type=script&lang=js&"
export * from "./SubscriptionForm.Purchase.InovioPayForm.vue?vue&type=script&lang=js&"
import style0 from "./SubscriptionForm.Purchase.InovioPayForm.vue?vue&type=style&index=0&id=2482ee6d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2482ee6d",
  null
  
)

component.options.__file = "SubscriptionForm.Purchase.InovioPayForm.vue"
export default component.exports